export enum EHideOfferState {
  INIT = 'INIT',
  FETCHING = 'FETCHING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface ISetHideOfferInfo {
  status: EHideOfferState;
  errorMessage?: string;
}

export interface IHideOffer {
  status: EHideOfferState;
  errorMessage?: string;
  isComplainOpened: boolean;
  isTopPopupOpened: boolean;
}

export interface IHideOfferComplainToggleAction {
  isComplainOpened: boolean;
  type: 'IHideOfferComplainToggleAction';
}

export interface IHideOfferTopPopupToggleAction {
  isTopPopupOpened: boolean;
  type: 'IHideOfferTopPopupToggleAction';
}

export interface ISetHideOfferState {
  type: 'ISetHideOfferState';
  status: EHideOfferState;
  errorMessage?: string;
}
